var base = require('./base');
var geolocationHelper = require('../geolocation/geolocationHelper');
/* global JSZip */

/**
 * Habilitar/Deshabilitar boton js-add-to-cart-global en product sets
 */
function updateGlobalAddToCart() {
    var addToCart = $('.js-add-to-cart');
    var enableBtn = true;

    if (addToCart.length === 0) {
        $(".js-add-to-cart-global").prop("disabled", true).removeClass("btn-outline-primary").addClass("btn-primary");
        enableBtn = false;
        return;
    }

    $.each(addToCart, function (i, el) {
        var isDisabled = $(el).prop('disabled');

        if (isDisabled) {
            // btn global add to cart always be enabled
            $(".js-add-to-cart-global").prop("disabled", false).removeClass("btn-primary").addClass("btn-outline-primary");
            enableBtn = false;
            return false;
        }

        return enableBtn;
    });

    if (enableBtn) {
        $(".js-add-to-cart-global").prop("disabled", false).removeClass("btn-primary").addClass("btn-outline-primary");
    }
}

/**
 * This function render availability message when cuantity is changed
 *
 * @param {Object} element - Element jquery to use
 */
function updateAvailabilityMessage(element) {
    setTimeout(() => {
        var parentDis = element.parents(".js-calculator");
        var stockInfo = parentDis.find(".cantidadDis.stock-info");
        var parentContentDis;
        
        if (!stockInfo.length) {
            parentContentDis = element.parents(".product-detail");
            stockInfo = parentContentDis.find(".cantidadDis.stock-info");
        }

        if (!stockInfo.length) {
            return;
        }

        parentContentDis = element.parents(".product-detail[data-pid='" + stockInfo.data("pid") + "']");
        if (!parentContentDis.length) {
            parentContentDis = element.parents(".product-detail");
        }

        var quantity = Number(element.val());
        var pid = stockInfo.data('pid');
        
        // Usar el almacén global de availability.js
        var storedStockInfo = window.app.globalStockInfo && window.app.globalStockInfo[pid];
        
        if (storedStockInfo) {
            // Si ya tenemos la información, actualizamos directamente
            var $availabilityContainer = parentContentDis.find(".product-availability-container");
            var $unavailabilityContainer = parentContentDis.find(".unavailability-msg-container");
            var addToCart = parentContentDis.find('.add-to-cart');

            if (quantity <= storedStockInfo.CANTIDAD && storedStockInfo.DISPONIBLE === 'SI') {
                $availabilityContainer.find('.dispExistencias').show();
                $availabilityContainer.find('.dispExistencias-mensaje').text(storedStockInfo.MENSAJE);
                $availabilityContainer.find('.dispExistenciasN').hide();
                $unavailabilityContainer.find('.unavailability-content').hide();

                addToCart.prop('disabled', false)
                    .removeClass('btn-primary')
                    .addClass('btn-outline-primary');
            } else {
                $availabilityContainer.find('.dispExistencias').hide();
                $availabilityContainer.find('.dispExistenciasN').show();
                $unavailabilityContainer.find('.unavailability-content').show();

                addToCart.prop('disabled', true)
                    .removeClass('btn-outline-primary')
                    .addClass('btn-primary');
            }
        }
    }, 500);
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}
/**
 * Calculate boxes quantity
 * @param {Object} thisEl - Element jquery edited
 */
function setDisabledButton(thisEl) {
    var productDetail = $(thisEl).closest('.product-detail');
    var calculator = $(thisEl).closest('.calculator');
    var metrosCaja = parseFloat(calculator.find('.metrosCaja').val());
    var metrosCajaDn = parseFloat(calculator.find('.metrosCajaDn').val());
    var cantidadDisInput = calculator.find('.cantidadDis');
    var dispExistenciasN = calculator.find('.dispExistenciasN');
    var dispExistencias = calculator.find('.dispExistencias');
    var addToCartBtn = productDetail.find('.add-to-cart');

    var cantidadProd = Math.ceil(metrosCaja / metrosCajaDn);
    if (cantidadProd > parseFloat(cantidadDisInput.val())) {
        dispExistenciasN.show();
        dispExistencias.hide();
        addToCartBtn.prop('disabled', true).removeClass("btn-outline-primary").addClass("btn-primary");
    } else {
        dispExistenciasN.hide();
        dispExistencias.show();
        addToCartBtn.prop('disabled', false).removeClass("btn-primary").addClass("btn-outline-primary");
    }
}
/**
 * Function to show or hide roomvo buttons in pdp
 */
function roomvoData () {
    var checkVisibilityInterval = setInterval(function() {
        var isVisibility360= $('.roomvo-product-display-button').css('visibility');
        var isVisibility= $('.roomvo-stimr').css('visibility');
        if ( isVisibility360 === 'visible') {
            $('.roomvo-container_3d').removeClass('d-none');
            clearInterval(checkVisibilityInterval);
        } else {
            $('.roomvo-container_3d').addClass('d-none');
        }
        if ( isVisibility === 'visible') {
            $('.roomvo-container').removeClass('d-none');
            clearInterval(checkVisibilityInterval);
        } else {
            $('.roomvo-container').addClass('d-none');
        }
    }, 100);
}
/**
 * Close modal All products in set in tablet and mobile
 */
function closeModalAllProductsInSet() {
    var modal = $('.set-items');
    modal.animate({ right: '-100%' }, 400, function() {
        modal.removeClass('show');
    });
    $("body").removeClass("overflow-hidden");
}

/**
 * Show modal All products in set in tablet and mobile
 */
function showModalAllProductsInSet() {
    var modal = $('.set-items');

    if ($(window).width() <= 1200) {
        modal.show().removeClass('d-none').addClass('show').animate({ right: '0' }, 400);
        $("body").addClass("overflow-hidden");
    } else {
        closeModalAllProductsInSet()
    }
}

/**
 * 
 * @param {*} file file
 */
function downloadZip(file) {
    const a = document.createElement('a');
    a.download = 'fotosProducto.zip';
    const url = URL.createObjectURL(file);
    a.href = url;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
}

/**
 * Returns the current date and time formatted as 'YYYY/MM/DD HH:MM:SS'.
 * 
 * @function
 * @returns {string} The current date and time in the format 'YYYY/MM/DD HH:MM:SS'.
 */
function getFormattedDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);
    const seconds = ('0' + now.getSeconds()).slice(-2);
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}
/**
 * Determines the user's operating system based on the browser's user agent.
 * 
 * @function
 * @returns {string} The user's operating system. Possible values include:
 *   - 'Windows'
 *   - 'macOS'
 *   - 'iOS'
 *   - 'Android'
 *   - 'Linux'
 *   - 'unknow' (if the operating system cannot be determined)
 */
function getOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows/i.test(userAgent)) return 'Windows';
    if (/macintosh|mac os x/i.test(userAgent)) return 'macOS';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';
    if (/android/i.test(userAgent)) return 'Android';
    if (/linux/i.test(userAgent)) return 'Linux';
    return 'unknow';
}
/**
 * Determina si el navegador está en modo incógnito y llama a la función de retorno con el resultado.
 * @function
 * @param {function(boolean): void} callback - Función de retorno que se llama con un valor booleano.
 * @returns {void} Esta función no retorna un valor directamente; usa el callback para proporcionar el resultado.
 */
function isIncognitoMode(callback) {
    var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    if (!fs) {
        // No se puede detectar si está en incógnito
        callback(false);
    } else {
        fs(window.TEMPORARY, 100, function() {
            // No está en modo incógnito
            callback(false);
        }, function() {
            // Está en modo incógnito
            callback(true);
        });
    }
}

/**
 * Get Device
 * @returns {string} DeviceType: 'Mobile', 'Tablet', o 'Web'.
 * 
 */
function getDeviceType() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) return 'Mobile';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'Mobile';
    if (/iPad/.test(userAgent) || (/Android/.test(userAgent) && !/Mobile/.test(userAgent))) return 'Tablet';
    return 'Web';
}
/**
 * Get brownserName
 * @returns {string} DeviceType: 'Safary', 'Opera', 'Firefox', etc
 */
function getBrowserName() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/chrome|crios|crmo/i.test(userAgent)) {
        return 'Chrome';
    }
    if (/firefox|fxios/i.test(userAgent)) {
        return 'Firefox';
    }
    if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) {
        return 'Safari';
    }
    if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) {
        return 'Opera';
    }
    if (/msie|trident/i.test(userAgent)) {
        return 'Internet Explorer';
    }
    if (/edge/i.test(userAgent)) {
        return 'Microsoft Edge';
    }
    return 'Unknown';
}
/**
 * Retrieves the user's IP address using the ipify API and calls the provided callback function with the result.
 * 
 * @function
 * @param {function(string): void} callback - A function to be called with the user's IP address.
 *   - Receives a parameter `data.ip` (a string) if the IP address is successfully retrieved.
 *   - Receives `'null'` as a string if the request fails.
 * @returns {void} This function does not return a value directly; it uses the callback to provide the result.
 */
function getIP(callback) {
    $.getJSON('https://api.ipify.org?format=json', function(data) {
        callback(data.ip);
    }).fail(function() {
        callback('null');
    });
}
module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements:
            updateAddToCartEnableDisableOtherElements
    },

    init: function () {
        updateGlobalAddToCart();

        var height = $(".render-attributes").height();

        if (height > 0) {
            $(".descargables-cont-mobile").addClass("mt-3");
        } else {
            $(".descargables-cont-mobile").removeClass("mt-3");
        }
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        /**
         * obtenerValor
         *
         * @param {*} etiqueta etiqueta
         * @param {*} datos datos
         * @return {*} valor
         */
        function obtenerValor(etiqueta, datos) {
            for (var i = 0; i < datos.length; i++) {
                if (datos[i].label === etiqueta) {
                    return datos[i].value[0];
                }
            }
            return null;
        }

        /**
         * mostrarOcultarValor
         *
         * @param {*} valor valor
         * @param {*} $elementoTexto elementoTexto
         * @param {*} $contenedor contenedor
         */
        function mostrarOcultarValor(valor, $elementoTexto, $contenedor) {
            if (valor) {
                $elementoTexto.text(valor).removeClass("d-none");
                $contenedor.removeClass("d-none");
            } else {
                $contenedor.addClass("d-none");
            }
        }
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $(
                '.product-detail[data-pid="' + data.id + '"]'
            );

            $productContainer
                .find('.description-and-detail .render-attributes')
                .empty()
                .html(data.attributesHtml);

            var height = $(".render-attributes").height();

            if (height > 0) {
                $(".descargables-cont-mobile").addClass("mt-3");
            } else {
                $(".descargables-cont-mobile").removeClass("mt-3");
            }

            if (data.shortDescription) {
                $('#collapsible-description').text(data.shortDescription);
                $productContainer
                    .find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }
            if (data.calculatorsHtml && $(".js-calculator").data("set-update") === "true") {
                $(".js-calculator").data("set-update", "false");
                $(".js-calculator").html(data.calculatorsHtml);
            }
            if (data.calculatorsHtml === "" && data.productType === "master") {
                $(".js-calculator").html(data.calculatorsHtml);
            }

            if (data.inventoryHtml.trim()) {
                $(".product-availability").empty().html(data.inventoryHtml);
                if (!data.readyToOrder || !data.available || (data.sinterExistencia && data.sinterExistencia.DISPONIBLE === "NO")) {
                    $(".unavailability-msg-container").find('.unavailability-content').show();
                    $(".js-add-to-cart").prop("disabled", true).removeClass("btn-outline-primary").addClass("btn-primary");
                } else {
                    $(".product-availability").find(".dispExistencias").show();
                    $(".product-availability").find(".dispExistencias-mensaje").text(data.sinterExistencia && data.sinterExistencia.MENSAJE ? data.sinterExistencia.MENSAJE : "");
                    $(".unavailability-msg-container").find('.unavailability-content').hide();
                    $(".js-add-to-cart").prop("disabled", false).removeClass("btn-primary").addClass("btn-outline-primary");
                }
            } else {
                $(".product-availability").empty();
            }

            if ((!data.readyToOrder || !data.available) && data.productType == "master") {
                $(".generate-quotation").prop("disabled", true);
            } else {
                $(".generate-quotation").prop("disabled", false);
            }


            var customAttributes= data.attributes;
            if (customAttributes && customAttributes.length > 0) {
                var attributeGroups = customAttributes
                    .filter(function(x) { return x.ID === "Ceramica" })
                    .map(function(x) { return x;});
                customAttributes = attributeGroups.length > 0 ? attributeGroups[0].attributes : customAttributes[0].attributes;

                var apariencia = obtenerValor("Apariencia", customAttributes);
                var cuerpo = obtenerValor("Tipo Cuerpo", customAttributes);
                var acabado = obtenerValor("Acabado Descripción", customAttributes);

                $(".content-cuerpo, .content-acabado, .content-apariencia").removeClass("d-none");

                mostrarOcultarValor(acabado, $(".txt-acabado"), $(".content-acabado"));
                mostrarOcultarValor(cuerpo, $(".txt-cuerpo"), $(".content-cuerpo"));
                mostrarOcultarValor(apariencia, $(".txt-apariencia"), $(".content-apariencia"));
                $('.roomvo-product-display-button').attr('data-sku', data.id);
                $('.roomvo-product-display-button').attr('data-roomvo-product-code', data.id);
                var usoDescripcion= data.usoDescripcion;
                var dataProductType = usoDescripcion == "Piso" || usoDescripcion == "Piso y pared" ? "floor" : "wall";
                $('.roomvo-stimr').attr('href', `javascript: roomvo.startStandaloneVisualizer('${dataProductType}', ${data.id});`);
                $(".roomvo-stimr").attr("data-sku", data.id);
                $('.roomvo-stimr').attr('data-roomvo-product-code', data.id);
                $('.roomvo-container').attr('data-product-type-str', dataProductType);
                $('.roomvo-product-display-button').attr('data-product-type-str', dataProductType);
                setTimeout(() => {
                    roomvoData();
                }, 1200);
            }
            if (data.longDescription) {
                $productContainer
                    .find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on(
            'product:beforeAddToCart product:beforeAttributeSelect',
            function () {
                $.spinner().start();
            }
        );
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
            }

            // Check if the product has a category bajo-pedido to show the buttons
            var bajoPedido = response.data && response.data.product && response.data.product.bajoPedido;
            if (bajoPedido || response.data.isKohler){
                $(".bajo-pedido-btns").removeClass("d-none");
                $('.generate-quotation').addClass('d-none');
                $('button.add-to-cart').addClass('d-none');
                $(".hidden-by-bp").addClass("d-none");

                var productId = response.data.product.id;
                var productName = response.data.product.productName;
                $(".form-on-request").find('input[name="productId"]').val(productId);
                $(".form-on-request").find('input[name="productName"]').val(productName);
                $(".launch-onrequest-modal").data("product-id", productId);
                $(".launch-onrequest-modal").data("product-name", productName);
            } else {
                $(".bajo-pedido-btns").addClass("d-none");
                $('.generate-quotation').removeClass('d-none');
                $('button.add-to-cart').removeClass('d-none');
                $(".hidden-by-bp").removeClass("d-none");
            }
            // check if exist artClave and show or hide the text
            var artClave = response.data && response.data.product && response.data.product.artClave;
            if (artClave){
                $(".product-art-clave").removeClass("d-none").text(artClave);
            } else {
                $(".product-art-clave").addClass("d-none").text("");
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            setDisabledButton($('.metrosCaja'));

            var enable = $('.product-availability')
                .toArray()
                .every(function (item) {
                    return (
                        $(item).data('available') &&
                        $(item).data('ready-to-order')
                    );
                });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(
                !enable
            );
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty()
                .html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(
                        allReady
                            ? response.message
                            : response.resources.info_selectforstock
                    );
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this)
                .closest('.size-chart')
                .find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (e) {
            var contentParent = $(this).parents(".social-container").parent();
            e.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($(this).siblings("input").val()).select();
            document.execCommand('copy');
            $temp.remove();
            $(contentParent).find('.copy-link-message').attr('role', 'alert');
            $(contentParent).find('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    validateAvailability: function () {
        $(document).on('change', '.CantidadProd', function () {
            if (window.isBlockSale) {
                return;
            }
            updateAvailabilityMessage($(this));
        });

        $(document).on('input', '.CantidadProd', function () {
            if (window.isBlockSale) {
                return;
            }
            updateAvailabilityMessage($(this));
        })
    },
    spCarouselModalMovil: function () {
        var carouselItem = $("#carousel-images-modal").find('.carousel-item');
        $('.sp-count-modal-movil').find(".currentVal").text(1 + "/" + carouselItem.length);

        $('#carousel-images-modal').on('slid.bs.carousel', function () {
            // Verificar si hay zoom activo
            if (window.isZoomActive && window.isZoomActive()) {
                return; // Si hay zoom activo, no ejecutar la función
            }
            
            var item = $(carouselItem).filter(".active");
            var currentVal = parseInt($(item).find(".sp-input-index-modal-movil").val(), 10) + 1;
            $('.sp-count-modal-movil').find(".currentVal").text(currentVal + "/" + carouselItem.length);
        })
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    showAllProductsInSet: function () {
        $(document).on('click', '.show-all-products', function () {
            if ($(window).width() <= 1200) {
                showModalAllProductsInSet();
            } else {
                $(".set-items").removeClass("d-none");
                $('html, body').animate({
                    scrollTop: $(".set-items").offset().top - 200
                });
            }
        });

        $(document).on('click', '.close-modal-btn', function () {
            closeModalAllProductsInSet();
        });

        $(window).resize(function() {
            if ($(window).width() <= 1200) {
                if (!$(".set-items").hasClass("show")) {
                    $(".set-items").removeClass('show').removeAttr('style');
                    $("body").removeClass("overflow-hidden");
                } else {
                    $("body").addClass("overflow-hidden");
                }
            } else {
                $("body").removeClass("overflow-hidden");
            }
        });
    },
    onChangeImagesCarousel: function () {
        $(document).on('click', '#set-container', function () {
            var index = $(this).data('index');
            var slideIndex = Number.parseInt(index, 10);
            $('#carousel-images-modal').carousel(slideIndex);
        });
    },
    descargables: function () {
        $(document).on('click', '.desc-directo-item', async () => {
            var urls = []
            var urlExt = false;
            $('.input-descargable-img').each(function (index) {
                try {
                    let path = new URL(window.origin + $(this).val());
                    urls.push(path);
                    urlExt = true;
                } catch (error) {
                    urls.push($(this).val());

                }
            });

            const promises = urls.map(async (url) => {
                const res = await fetch(url, {mode: 'no-cors'});
                const blob = await res.blob();
                return blob;
            })

            const res = await Promise.all(promises);

            const zip =  new JSZip();
            res.forEach((blob, index) => {
                zip.file('image'+index+'.jpeg', blob);
            });

            const zipFile = await zip.generateAsync({type: 'blob'});

            downloadZip(zipFile);
        })
    },
    onDownload: function() {
        $(document).on('click', '.custom-dropdown-button', function(event) {
            event.stopPropagation();
            $(this).next(".custom-dropdown-content").toggleClass("show");
        });
        
        $(document).on('click', function() {
            $(".custom-dropdown-content").removeClass("show");
        });
        
        $(document).on('click', '.custom-dropdown-content', function(event) {
            event.stopPropagation();
        });        
    }, 
    roomvoValidate: function () {
        $(document).ready(function() {
            setTimeout(() => {
                roomvoData();
            }, 1200);
        });
    },
    roomvoEvent: function() {
        $(document).ready(function() {
            $('.roomvo-gtm').on('click', function() {
                const userAgent = getOS();
                var productId = $(this).closest('.product-detail').find('.product-id').first().text();
                var dateTime = getFormattedDateTime();
                var deviceType = getDeviceType();
                var browser= getBrowserName();
                var isauthenticated = $('.is-authenticated-header').length > 0;
                var customerID =$('#customerID').val();
                var currentCGroup =$('#currentCGroup').val();
                var locationText = $('.submenu-locate').text();
                var gtmSku = $(this).attr('data-gtm-sku');
                var locationData = $('.location-con.location-section').data('location-in-session');
                locationData = locationData ? locationData : "";
                isIncognitoMode(function(isIncognito) {
                    getIP(function(ipAddress) {
                        window.dataLayer.push({
                            "event": "roomvo",
                            "item_id": productId ? productId : gtmSku,
                            "customer_id": isauthenticated && customerID!="null" ? customerID : "",
                            "customer_group": isauthenticated && currentCGroup!="null" ? currentCGroup : locationData,
                            "city_state": locationText ? locationText : "",
                            "date_hour": dateTime,
                            "ip_address": ipAddress,
                            "type_device": deviceType,
                            "mode": isIncognito ? "Incognito" : "Normal",
                            "browser": browser,
                            "section": "Detalle del producto",
                            "operating_system": userAgent
                        });
                    });
                });
            });
        });
    },
    showVirtualTour: function() {
        $(document).ready(function() {
            var urlParams = new URLSearchParams(window.location.search);
            var showVirtualTour = urlParams.get('show-virtual-tour');
            if (showVirtualTour) {
                $("#prod-desc-recorrido-virtual").trigger("click");
            }
        });
    }
};

/**
 * Function to list the cities of a state
 * @param {string} city - The city to list
 * @param {string} state - The state to list
 */
async function listModalCity(city, state) {
    var stateNumber = state ? state : $('#stateOnRequest').val();
    const url =$('[data-geolocation-municipios-url]').first().data("geolocationMunicipiosUrl");
    await $.ajax({
        url: url,
        method: 'Get',
        data: {
            'estado': stateNumber
        },
        async: true,
        success: function (data) {
            var citySelector = $('.on-request').find('.city-selector');
            var municipalities = data.municipios;
            citySelector.empty();
            var selected = false;
            for (var i = 0; i < municipalities.length; i++) {
                if (city && city == municipalities[i].municipality) {
                    selected = true;
                    citySelector.append('<option value="' + municipalities[i].municipality + '" selected>' + municipalities[i].municipality + '</option>');
                } else {
                    citySelector.append('<option value="' + municipalities[i].municipality + '">' + municipalities[i].municipality + '</option>');
                }
            }
        }
    });
}

$('#stateOnRequest').change(async function() {
    await listModalCity("");
});

/**
 * Restrict input to letters only
 * @param {string} selector - The selector of the input field
 */
function restrictToLetters(selector) {
    $(selector).on('input', function() {
        this.value = this.value.replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1\s´`¨^]/g, '');
    });
}

var restrictToLettersSelectors = $('.restrict-to-letters');

if (restrictToLettersSelectors.length) {
    restrictToLetters(restrictToLettersSelectors);
}

/**
 * Restrict input to numbers only
 * @param {string} selector - The selector of the input field
 */
function restrictToNumbers(selector) {
    $(selector).on('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length > 10) {
            this.value = this.value.slice(0, 10);
        }
    });
}

var restrictToNumbersSelectors = $('.restrict-to-numbers');

if (restrictToNumbersSelectors.length) {
    restrictToNumbers(restrictToNumbersSelectors);
}

// On request form submission handling
$(".form-on-request").submit(function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = $(this);
    
    var url = form.attr('action');
    var dataParams = {
        firstName: form.find('input[name="firstName"]').val(),
        lastName: form.find('input[name="lastName"]').val(),
        email: form.find('input[name="email"]').val(),
        phone: form.find('input[name="phone"]').val(),
        state: form.find('select[name="state"] option:selected').text(),
        city: form.find('select[name="city"]').val(),
        company: form.find('input[name="company"]').val(),
        quantity: form.find('input[name="quantity"]').val(),
        productId: form.find('input[name="productId"]').val(),
        productName: form.find('input[name="productName"]').val(),
        sucursal: form.find('input[name="sucursal"]').val(),
    };
    if (dataParams.quantity == 0 || dataParams.quantity == '0') {
        form.find('input[name="quantity"]').next().text('La cantidad debe ser mayor a 0').show();
        return;
    } 
    if (dataParams.quantity > 0 || dataParams.quantity !== '0') {
        form.find('input[name="quantity"]').next().hide();
    }
    
    $.ajax({
        url: url,
        method: 'POST',
        data: dataParams,
        success: function(data) {
            var modalSuccess = $(".on-request").find('.modal-success');
            $(".on-request").find('.modal-form').addClass('d-none');
            if (data.success) {
                modalSuccess.removeClass('d-none');
                modalSuccess.attr('data-success', 'valid');
                form.find('input[name="firstName"]').val(form.find('input[name="firstName"]').data('default'));
                form.find('input[name="lastName"]').val(form.find('input[name="lastName"]').data('default'));                form.find('input[name="email"]').val(form.find('input[name="email"]').data('default'));
                form.find('input[name="phone"]').val(form.find('input[name="phone"]').data('default'));
                form.find('input[name="company"]').val('');
                form.find('input[name="quantity"]').val('1');
            } else {
                modalSuccess.attr('data-success', 'invalid');
                modalSuccess.removeClass('d-none');
            }
        }
    });
});



$(".launch-onrequest-modal").click(function(event) {
    // show modal
    $(".on-request").find('.modal-form').removeClass('d-none');
    $(".on-request").find('.modal-success').addClass('d-none');
    let savedCookieLocation = geolocationHelper.getCookie('dataUserObtenerMunicipios');
    let productId = $(this).data('product-id');
    let productName = $(this).data('product-name');

    // Set the product id and name in the form
    $(".on-request").find('input[name="productId"]').val(productId);
    $(".on-request").find('input[name="productName"]').val(productName);
    var stateSelector = $('.on-request').find('#stateOnRequest');
    var selectedState = false;

    // If the user has saved a location, set the state and city in the form by default
    if(savedCookieLocation) {
        var data = JSON.parse(savedCookieLocation);
        var state = data.ESTADO;
        var city = data.NOMBRE;
        stateSelector.find('option').each(function() {
            if ($(this).text() == state) {
                selectedState = true;
                var stateNumber = $(this).val();
                $(this).prop('selected', true);
                listModalCity(city, stateNumber)
            }
        });
    }
    if (!selectedState) {
        stateSelector.trigger('change');
    }
});

$(document).ready(function() {
    let url = $('#wishlist-get-json-list').val();
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            if (!response || !response.itemsId || response.itemsId.length === 0) {
                return;
            };
            let itemsId = response.itemsId;
            window.itemsInFavorites = itemsId;
            let pdpWishlist = $('.btn-wishlist');
            
            // Check if the product is in the wishlist in the product detail page
            pdpWishlist.each(function () {
                let pid = $(this).closest(".product-detail").data('pid');
                if (itemsId[pid]) {
                    $(this).find('i').toggleClass('fa-heart fa-heart-o heart-white');
                }
            });

            // Check if the product is in the wishlist in the product set description
            let productSet = $('.set-product-desc');
            if (productSet.length && itemsId[productSet.find('.product-id').text()]) {
                productSet.find('.wishlist-icon').toggleClass('fa-heart-o fa-solid fa-heart heart-white');
            }
            // Check if the product in the product set list is in the wishlist 
            let productSetBtns = $('.product-info-btns-section');
            productSetBtns.each(function () {
                if (itemsId[$(this).data('pid')]) {
                    $(this).find('i').toggleClass('fa-heart-o fa-solid fa-heart heart-white');
                }
            });

            // Wait for all the products in carousel to be loaded
            setTimeout(() => {
                // Check if the product in the products carousel is in the wishlist
                let wishlistTiles = $('.wishlistTile');
                wishlistTiles.each(function () {
                    let pid = $(this).data('pid') || $(this).closest(".product").data('pid');
                    if (itemsId[pid]) {
                        $(this).find('i').toggleClass('heart-white');
                    }
                });
            }, 500);
        }
    });

    $('.check-download-file').click(function (event) {
        var href = $(this).attr('href');
        if (href) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            try {
                var urlAws = new URL(href);
                var pathFile = urlAws.pathname;
                var productId = $(this).parent().data('product-id');
                var productName = $(this).parent().data('product-name');
                
                var fileCheckUrl = $(this).data('file-check');
                $.ajax({
                    url: fileCheckUrl,
                    type: 'GET',
                    data: { fileSource: pathFile, productId: productId, productName: productName },
                    success: function (data) {
                        if (!data.success) {
                            window.open(href, '_blank');
                            return;
                        }

                        if (data.success && data.fileExists) {
                            window.open(href, '_blank');
                            return;
                        }

                        let errorModalIsRendered = $('#errorModalFileNotFound').length;
                        if (data.errorModalHtml && !errorModalIsRendered) {
                            $('body').append(data.errorModalHtml);
                        }
                        
                        if (data.success && !data.fileExists) {
                            $('#errorModalFileNotFound').modal('show');
                        }
                    },
                    error: function (xhr, status, error) {
                        window.open(href, '_blank');
                    }
                });
            } catch (error) {
                window.open(href, '_blank');
            }
        }
    });
    var isPdp = $('.product-detail').length > 0;
    var footerContent = $('#footercontent');
    if (footerContent && footerContent.length && isPdp) {
        footerContent.addClass('footer-margin-bottom');
    }
});
